export const storyblokProductSearchFiltersParsePromotionIdToQueryString = (
  _fieldName: string,
  promotionId: string,
): string | null =>
  promotionId ? `best_offer.seller_promotion.promotionId=${promotionId}` : null
